/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Psychodietetics_TermsInputs */

const en_service_type_psychodietetics_terms = /** @type {(inputs: Service_Type_Psychodietetics_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`emotional eating, binge eating, eating habits, relationship with food`)
};

const pl_service_type_psychodietetics_terms = /** @type {(inputs: Service_Type_Psychodietetics_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`psychodietetyk, zajadanie emocji, kompulsywne jedzenie, nawyki żywieniowe, relacja z jedzeniem`)
};

/**
* | output |
* | --- |
* | "emotional eating, binge eating, eating habits, relationship with food" |
*
* @param {Service_Type_Psychodietetics_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_psychodietetics_terms = /** @type {((inputs?: Service_Type_Psychodietetics_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Psychodietetics_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_psychodietetics_terms(inputs)
	return en_service_type_psychodietetics_terms(inputs)
});